import React from 'react';
import { useHistory } from 'react-router-dom';

import appRoutes from '../../../../../../../../routes/appRoutes';
import CashbackPresenter from '../../../../../../../../presenters/CashbackPresenter';
import { ElementLink } from '../../../../../../../../components';

const Cashback = (props) => {
  const { cashback, previousCashback } = props;
  const isFirstDateFromGroup =
    CashbackPresenter.date(cashback) !==
    CashbackPresenter.date(previousCashback);

  const history = useHistory();

  const handleRedirectToCashback = (e) => {
    e.stopPropagation();

    const path = appRoutes.transactionPath(cashback.plaidTransactionId);
    history.push(path);
  };

  const transactionAmountReadable =
    CashbackPresenter.transactionAmountReadable(cashback);

  return (
    <React.Fragment>
      {isFirstDateFromGroup && (
        <tr className="date-group-title">
          <td colSpan="8">{CashbackPresenter.date(cashback)}</td>
        </tr>
      )}
      <ElementLink
        element="tr"
        to={appRoutes.cashbackPath(CashbackPresenter.id(cashback))}
        className="cashback-cell"
      >
        <td>{CashbackPresenter.date(cashback)}</td>
        <td>{CashbackPresenter.name(cashback)}</td>
        <td>{CashbackPresenter.amountReadable(cashback)}</td>
        <td>{CashbackPresenter.rateReadable(cashback)}</td>
        <td>
          <div>{CashbackPresenter.state(cashback)}</div>
          {CashbackPresenter.isQuarantined(cashback) && (
            <div>{`reason: ${CashbackPresenter.quarantinedReasonReadable(
              cashback
            )}`}</div>
          )}
        </td>
        <td>
          {CashbackPresenter.hasPlaidTransaction(cashback) ? (
            <button
              className="nav-button"
              onClick={handleRedirectToCashback}
              role="link"
            >
              {transactionAmountReadable}
            </button>
          ) : (
            transactionAmountReadable
          )}
        </td>
      </ElementLink>
    </React.Fragment>
  );
};

Cashback.propTypes = {
  cashback: CashbackPresenter.shape().isRequired,
  previousCashback: CashbackPresenter.shape(),
};

Cashback.defaultProps = {
  previousCashback: null,
};

export default Cashback;
